import { useServiceRecordNavigation } from '@euler/app/flows/record/functions/useServiceRecordNavigation';
import { useServiceRecordContext } from '@euler/app/flows/record/ServiceRecordContext';
import { SettlementFormFooter } from '@euler/app/flows/task/pages/quotation/components/SettlementFormFooter';
import { SettlementFormView } from '@euler/app/flows/task/pages/quotation/components/SettlementFormView';
import { usePrintQuotationForm } from '@euler/app/flows/task/pages/quotation/functions/usePrintQuotationForm';
import { Aside } from '@euler/components/Aside';
import { adaptiveWrapperOptions } from '@euler/functions/navigationOptionsBuilder';
import {
  isMobileLayout,
  useIsMobileLayout,
} from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { memo, useCallback } from 'react';
import invariant from 'tiny-invariant';

export const ServiceRecordSettlementFormPage = wrapNavigatorScreen(
  () => {
    const isMobile = useIsMobileLayout();

    if (isMobile) {
      return <Content />;
    }
    return (
      <Aside dismissible>
        <Content />
      </Aside>
    );
  },
  adaptiveWrapperOptions<any>(() => ({
    title: '维修结算单',
    headerStatusBarHeight: undefined,
    headerShown: isMobileLayout(),
  })),
);

const Content = memo(() => {
  const { serviceRecord } = useServiceRecordContext();
  const form = serviceRecord.settlementForm;
  invariant(form != null);

  const navigation = useServiceRecordNavigation();

  const onViewQuotationForm = useCallback(() => {
    navigation.push('_quotationForm', {});
  }, [navigation]);

  const onPrint = usePrintQuotationForm(serviceRecord.orderNo, {
    type: 'settlement-form',
    showPrice: true,
  });

  return (
    <>
      <SettlementFormView form={form} />
      <SettlementFormFooter
        form={form}
        onPrint={onPrint}
        onViewQuotationForm={onViewQuotationForm}
      />
    </>
  );
});
